import $ from 'jquery';
import {debounce} from 'throttle-debounce';

const tipprundeNameInput = debounce(
    300,
    () => {
        const nameValue = $('#name').val();
        const tipprundeId = $('#tipprundeId').val();
        validate(nameValue, tipprundeId);
    },
    {atBegin: false}
);

async function validate(nameValue, tipprundeId) {
    const body = tipprundeId ? JSON.stringify({query: '{tipprundeNameValidation(tipprundeId: ' + tipprundeId + ', name: "' + nameValue.replaceAll('"', '\\"') + '"){name kurzname errorMessage valid}}'}) : JSON.stringify({query: '{tipprundeNameValidation(name: "' + nameValue.replaceAll('"', '\\"') + '"){name kurzname errorMessage valid}}'});
    const response = await fetch(
        '/graphql',
        {
            method: 'post',
            body: body,
            headers: {
                'Content-Type': 'application/json',
                'Content-Length': body.length,
            },
        }
    );
    const kicktippDomainValue = $('#kicktippDomain').html();

    const json = await response.json();
    if (json.data.tipprundeNameValidation.valid) {
        $('#tippspielUrlKurzname').html(kicktippDomainValue + "/" + json.data.tipprundeNameValidation.kurzname);
        $('#nameErrors').hide();
        $('#nameLabel').removeClass('errorLabel');
    }
    if (!json.data.tipprundeNameValidation.valid) {
        $('#tippspielUrlKurzname').html(kicktippDomainValue + "/" + json.data.tipprundeNameValidation.kurzname);
        $('#nameErrors').html(json.data.tipprundeNameValidation.errorMessage);
        $('#nameErrors').show();
        $('#nameLabel').addClass('errorLabel');
    }
}

window.addEventListener('DOMContentLoaded', function () {
    $('#name').on('input', tipprundeNameInput);
});